import React from "react";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const AssetNameColumn = ({ data }: Props) => {
	if (data) {
		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{data.AssetName}
				</Grid2>
			</Grid2>
		);
	} else {
		return <></>;
	}
};
